__turbopack_context__.v({
  "ButtonLoading": "Button-module__rzDpbW__ButtonLoading",
  "ButtonSpinner": "Button-module__rzDpbW__ButtonSpinner",
});
